export interface IAppSwitcherProducts {
  entitled: IProductDetails[];
  unentitled: IProductDetails[];
}
export interface IProductDetails {
  entitlementProductKey: string;
  displayName: string;
  url: string;
  description: string;
  openInNewTab: boolean;
  icon?: string;
}
export enum PRODUCT_ICONS {
  financial = `product-fin`,
  procurement = `product-pro`,
  budget = `product-b&p`,
  cit = `product-cit`,
  reporting = `product-r&t`,
  oth = `product-oth`,
  od = `product-od`,
  eam = 'product-eam'
}
export type FEDERATED_SERVICEIDS_TYPE =
  | 'BY_CKAN_CUSTOMER_ID'
  | 'BY_OTH_PORTAL_ID'
  | 'BY_FINANCIALS_CUSTOMER_ID'
  | 'BY_CIT_COMMUNITY_ID'
  | 'BY_PROCUREMENT_ID'
  | 'BY_ASSET_MANAGEMENT_ID'
  | 'BY_FRIENDLY_ID';
